import { motion } from "framer-motion";
import { useMoodConfig } from "../stats/MoodChart";

export const CustomDot = ({ cx, cy, value, index }) => {
    if (!value) return null;

    const moodConfig = useMoodConfig();
    const moodInfo = moodConfig[value];

    return (
        <motion.g
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
                type: "spring",
                stiffness: 500,
                damping: 30,
                delay: index * 0.05
            }}
        >
            <circle
                cx={cx}
                cy={cy}
                r={4}
                fill={moodInfo.color}
            />
            <motion.circle
                cx={cx}
                cy={cy}
                r={8}
                fill={moodInfo.color}
                fillOpacity={0.2}
                animate={{
                    r: [8, 10, 8],
                    fillOpacity: [0.2, 0.3, 0.2]
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
            />
        </motion.g>
    );
};

export default CustomDot;